const initialState = {
  searchFlightsResult: {},
};

const searchFlightsResult = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FLIGHTS_RESULT':
      return {
        // initialState = action.payload
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default searchFlightsResult;
